// @ts-ignore
/* eslint-disable */
import { request } from "@umijs/max"

/** 运营通知-分页查询 POST /web/v1/operationMessage/pageList */
export async function getOperationMessagePageList(
  body: any,
  options?: { [key: string]: any }
) {
  return request<any>("/web/v1/operationMessage/pageList", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 运营通知-新增或更新 POST /web/v1/operationMessage/upsert */
export async function upsertOperationMessage(
  body: any,
  options?: { [key: string]: any }
) {
  return request<any>("/web/v1/operationMessage/upsert", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 运营通知-详情 GET /web/v1/operationMessage/detail/{id} */
export async function getOperationMessageDetail(
  params: { id: number },
  options?: { [key: string]: any }
) {
  const { id } = params as any;
  return request<any>(`/web/v1/operationMessage/detail/${id}`, {
    method: "GET",
    ...(options || {}),
  });
}

/** 运营通知-终止 POST /web/v1/operationMessage/terminate/{id} */
export async function terminateOperationMessage(
  params: { id: number },
  options?: { [key: string]: any }
) {
  const { id } = params as any;
  return request<any>(`/web/v1/operationMessage/terminate/${id}`, {
    method: "POST",
    ...(options || {}),
  });
}

/** 运营通知-发布 POST /web/v1/operationMessage/publish/{id} */
export async function publishOperationMessage(
  params: { id: string | number },
  options?: { [key: string]: any }
) {
  const { id } = params as any;
  return request<any>(`/web/v1/operationMessage/publish/${id}`, {
    method: "POST",
    ...(options || {}),
  });
}


